import { useState } from "react";
import "./Navbar.css";
import { BrowserRouter, Route, Link, NavLink } from "react-router-dom";
import NathanImg3 from "../../assets/images/banner/nathan-image-3.png";
import "../../assets/css/home.css";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  const toggleDropdown = () => {
    setToggle(!toggle);
  };
  return (
    <div
      className="container-fluid position-sticky top-0"
      style={{ zIndex: "10" }}
    >
      <div className="poetsen-one-regular">
        <nav className="navbar-bg">
          <div className="container aclonica-regular">
            <nav className="navbar navbar-expand-lg">
              <div className="container-fluid">
                <a className="navbar-brand" href="/home" target="_blank">
                  <img
                    src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1722329672/naffan_in_car_1_cote6w.png"
                    alt="nav-logo"
                    width="60"
                    height="55"
                  />
                </a>
                <div className="social-links">
                  <a
                    href="https://x.com/Condo_Base?t=pDe6ikBbmBG1q4lVTt1Ckw&s=09"
                    target="_blank"
                  >
                    {" "}
                    <i className="fa-brands fa-x-twitter"></i>
                  </a>

                  <a href="https://t.me/Condo_Official" target="_blank">
                    <i className="fa-brands fa-telegram ms-3"></i>
                  </a>
                  <a
                    href="https://medium.com/@condobasechain/condo-the-memetoken-investing-in-real-world-assets-33a17b51bac9"
                    target="_blank"
                  >
                    {" "}
                    <i className="fa-brands fa-medium ms-3 fa-lg"></i>
                  </a>
                  <a
                    href="https://www.geckoterminal.com/base/pools/0xef9bccfba3a62e0a50d288a3031ca18f41f6c000"
                    target="_blank"
                  >
                    {" "}
                    <img
                      src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1712927079/geckoterminal_icon_liduyt.png"
                      width="25"
                      alt=""
                      className="ms-3"
                    />
                  </a>
                </div>
                <button
                  className="navbar-toggler"
                  type="button"
                  // data-bs-toggle="collapse"
                  // data-bs-target="#navbarSupportedContent"
                  // aria-controls="navbarSupportedContent"
                  aria-expanded={toggle}
                  aria-label="Toggle navigation"
                  onClick={toggleDropdown}
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div
                  className={
                    toggle
                      ? `collapse navbar-collapse show`
                      : "collapse navbar-collapse"
                  }
                  // id="navbarSupportedContent"
                >
                  <ul className="navbar-nav m-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                      <a className="nav-link" href="/home">
                        Home
                      </a>
                    </li>
                    {/* <li className="nav-item">
                      <a className="nav-link" href="#tokenomics">
                        Tokenomics
                      </a>
                    </li> */}
                    {/* <li className="nav-item">
                      <a
                        className="nav-link"
                        target="_blank"
                        href="https://taskon.xyz/cmuser/Condo/task"
                      >
                        Airdrop
                      </a>
                    </li> */}
                    <li className="nav-item">
                      <a className="nav-link" href="/home/treasury-overview">
                        Treasury Overview
                      </a>
                    </li>{" "}
                    <li className="nav-item">
                      <a className="nav-link" href="/home/token">
                        Token
                      </a>
                    </li>
                  </ul>
                  <div className="d-flex gap-2 search-btns" role="search">
                    {/* <button
                    className="btn nav-btns-bg"
                    type="submit"
                    style="color: white"
                  >
                    Connect
                  </button> */}
                    <a
                      href="https://app.uniswap.org/explore/tokens/base/0x30d19fb77c3ee5cfa97f73d72c6a1e509fa06aef"
                      target="_blank"
                    >
                      <button
                        className="btn nav-btns-bg"
                        style={{ color: "white" }}
                      >
                        Buy
                      </button>{" "}
                    </a>
                  </div>
                  {/* <div className="social-links-mobile">
                    <a
                      href="https://x.com/Condo_Base?t=pDe6ikBbmBG1q4lVTt1Ckw&s=09"
                      target="_blank"
                    >
                      {" "}
                      <i className="fa-brands fa-x-twitter fa-xl"></i>
                    </a>
                    <a href="https://t.me/Condo_Official" target="_blank">
                      {" "}
                      <i className="fa-brands fa-telegram ms-3 fa-xl"></i>
                    </a>
                    <a
                      href="https://medium.com/@condobasechain/condo-the-memetoken-investing-in-real-world-assets-33a17b51bac9"
                      target="_blank"
                    >
                      {" "}
                      <i className="fa-brands fa-medium ms-3 fa-lg"></i>
                    </a>
                    <a
                      href="https://www.geckoterminal.com/base/pools/0xef9bccfba3a62e0a50d288a3031ca18f41f6c000"
                      target="_blank"
                    >
                      {" "}
                      <img
                        src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1712927079/geckoterminal_icon_liduyt.png"
                        width="25"
                        alt=""
                        className="ms-3"
                      />
                    </a>
                  </div> */}
                </div>
              </div>
            </nav>
          </div>
        </nav>
        <hr style={{ margin: "0" }} />
      </div>
    </div>
  );
};

export default Navbar;
